import React from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const displayValue = (value) => typeof value === "string" ? value : JSON.stringify(value ?? "");

export default function EventRsvpAnswerCard({ id, title, textLabel, text, textReadOnly = false, answer, disabled, showAttendance, onChange, onRemove, removeDisabled, children }) {
  return <Card className="mb-4 shadow-none overflow-hidden" style={{ border: "1px solid #cbd5e1", borderRadius: 8 }}>
    <Card.Header className="d-flex align-items-center justify-content-between gap-2 py-2 px-3" style={{ backgroundColor: "#f2f4f7", borderBottom: "1px solid #e2e8f0" }}>
      <span className="fw-semibold">{title}</span>
      {onRemove && <Button size="sm" variant="outline-danger" disabled={disabled || removeDisabled} onClick={onRemove} title="Remover resposta" aria-label={`Remover ${title.toLowerCase()}`}><FontAwesomeIcon icon={faTrash} /></Button>}
    </Card.Header>
    <Card.Body className="p-3">
      {children}
      <Row className="g-3">
        <Form.Group as={Col} md={6} controlId={`${id}-text`}>
          <Form.Label className="small">{textLabel}</Form.Label>
          <Form.Control maxLength={textReadOnly ? undefined : 120} readOnly={textReadOnly} className={textReadOnly ? "bg-light" : undefined} value={text ?? answer?.label ?? ""} disabled={disabled} onChange={textReadOnly ? undefined : (event) => onChange("label", event.target.value)} />
        </Form.Group>
        <Form.Group as={Col} md={6} controlId={`${id}-value`}>
          <Form.Label className="small">Valor registrado</Form.Label>
          <Form.Control maxLength={500} value={displayValue(answer?.value)} disabled={disabled || !answer} onChange={(event) => onChange("value", event.target.value)} />
        </Form.Group>
      </Row>
    </Card.Body>
    {showAttendance && <Card.Footer className="bg-light py-3 px-3" style={{ borderTop: "1px solid #e2e8f0" }}>
        <Form.Check id={`${id}-attendance`} label="Conta como presença no evento" checked={answer?.counts_as_attendance === true} disabled={disabled || !answer} onChange={(event) => onChange("counts_as_attendance", event.target.checked)} />
    </Card.Footer>}
  </Card>;
}
